<div *ngFor="let subField of fields" fxLayout="row" fxLayoutAlign="space-between">
  <div class="sub-title">
    {{ subField.key }}
  </div>
  <div fxLayout="column">
    <div *ngIf="!subField.values?.length">(empty)</div>
    <display-data
      *ngFor="let valuesObj of subField.values"
      [value]="valuesObj.value"
      [attributeUiType]="subField.type"
    ></display-data>
  </div>
</div>
